import { render, staticRenderFns } from "./Pc.vue?vue&type=template&id=53435c03&scoped=true&"
import script from "./Pc.vue?vue&type=script&lang=js&"
export * from "./Pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53435c03",
  null
  
)

export default component.exports